// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const tinRock = defineModel({
  id: "tin-rock",
  batchId: "future",
  name: "Tin rock",
  tags: ["scenery","tin","rock","low-poly","age-of-mcp","future"],
  summary: "Tin ore. Alloyed with copper to make bronze, and used for tinning and solder.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.45,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.33, 0), color: "#7a7d84", position: [0, 0.23, 0], rotation: [0, 0.5, 0.04], scale: [1.1, 0.95, 1.05] },
      { geometry: new THREE.IcosahedronGeometry(0.19, 0), color: "#6c6f76", position: [-0.24, 0.15, 0.06], rotation: [0.1, 1.2, 0], scale: [1, 0.85, 0.95] },
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#7d8b9a", position: [0.16, 0.28, 0.14], rotation: [0.1, 0.6, 0.2], scale: [1, 0.95, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#93a1b0", position: [0.04, 0.36, 0.16], rotation: [0.2, 1, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.09, 0), color: "#69757f", position: [0.22, 0.18, 0.06], rotation: [0.1, 1.6, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#7d8b9a", position: [0.1, 0.2, 0.24], rotation: [0.2, 0.4, 0.3] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#93a1b0", position: [-0.06, 0.4, 0.04], rotation: [0.1, 0.8, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#69757f", position: [-0.16, 0.3, 0.16], rotation: [0.2, 1.2, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#7d8b9a", position: [0.19, 0.04, 0.13], rotation: [0.2, 0.6, 0.2], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#93a1b0", position: [-0.2, 0.04, -0.05], rotation: [0.3, 1, 0.2] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#6c6f76", position: [0.04, 0.04, -0.2], rotation: [0.3, 0.4, 0.3] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#7a7d84", position: [-0.13, 0.03, 0.2], rotation: [0.2, 0.8, 0.2], scale: [1.1, 0.7, 1] },
    ],
  animations: [],
});
